import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";
import { UserDetailed } from "../types";

export const useUser = (userId: string) => {
  return useQuery({
    queryKey: ["user", userId], // Key used to cache the request
    enabled: userId.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(`${USER_API_URL}/waves-user-manager-api/v1/users/${userId}`, {
          signal
        })
        .then((response) => {
          return response.data as UserDetailed;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
